'use client';

import Image from 'next/image';
import Link from 'next/link';

import { cn } from '@/lib/utils';

type BrandProps = {
  href: string;
  className?: string;
  onClick?: () => void;
  priority?: boolean;
};

export function Brand({ href, className, onClick, priority }: BrandProps) {
  return (
    <Link
      href={href}
      className={cn('flex shrink-0 items-center gap-1', className)}
      onClick={onClick}
    >
      <Image
        src='/logos/skill4skill-logo-icon.svg'
        alt='Skill4Skill Logo'
        width={48}
        height={48}
        priority={priority}
      />
      <span className='ml-2 text-xl font-bold text-brand-base'>
        Skill4Skill
      </span>
    </Link>
  );
}
